import { z } from 'zod'
import { newInstitutionSchema } from '@/lib/schemas/new-institution'

/** Public /start only accepts identity and wording, never privileged org settings. */
export const startInstitutionProfileSchema = z
  .object({
    shortName: newInstitutionSchema.shape.shortName,
    color: newInstitutionSchema.shape.color,
    language: newInstitutionSchema.shape.language,
    timezone: newInstitutionSchema.shape.timezone,
    institutionType: newInstitutionSchema.shape.institutionType,
    alumniWord: newInstitutionSchema.shape.alumniWord,
    classYearTerm: newInstitutionSchema.shape.classYearTerm,
    logoPreview: newInstitutionSchema.shape.logoPreview,
  })
  .strict()

export type StartInstitutionProfile = z.output<typeof startInstitutionProfileSchema>

export function parseStartInstitutionProfile(raw: unknown) {
  if (raw === null || raw === undefined || raw === '') return { success: true, data: null } as const
  if (typeof raw !== 'string' || raw.length > 1_510_000) return { success: false } as const
  try {
    return startInstitutionProfileSchema.safeParse(JSON.parse(raw))
  } catch {
    return { success: false } as const
  }
}
